import { useI18n } from "@wojo/localization";
import { Text } from "@wojo/ui";
import cn from "clsx";
import React from "react";
import { getCurrency, useTripComponentType } from "../../../../hooks";
import { useTripBuilderQuote } from "../context/TripBuilderQuoteStepContext";
import styles from "./TripBuilderQuoteStep.module.scss";
import { TripComponentType } from "../../../../generated/graphql";
import { calculateTotalPricePerPromoTarget } from "../../../../hooks";

export const QuoteSavings: React.FC = () => {
    const { formatCurrency } = getCurrency();
    const { draftQuote } = useTripBuilderQuote();
    const { productPage } = useI18n("productPage");
    const { getComponentLabel } = useTripComponentType();
    const promoLineItems =
        draftQuote?.order.trips.flatMap((trip) => trip.openPromoLineItems) ??
        [];

    if (promoLineItems.length === 0) {
        return null;
    }

    const promoTargetTotalsByCode =
        calculateTotalPricePerPromoTarget(promoLineItems);

    const getTargetDisplayLabel = (targetType?: TripComponentType | null) => {
        switch (targetType) {
            case TripComponentType.Promo:
            case TripComponentType.Tour:
                return "";
            default:
                return getComponentLabel(targetType);
        }
    };

    return (
        <dl
            aria-label={productPage.tripBuilder.quote.summary.savingsLabel.l()}
            className={cn(styles["value-group"], styles["value-group--padded"])}
            style={{
                color: "var(--s-color-promo-deal-standard)",
                borderBottom:
                    "var(--s-border-width-background-standard) solid var(--s-color-separator-standard)",
            }}
        >
            {promoTargetTotalsByCode.map((promoGroup) => {
                const { promoCode, campaignCode, targetType, totalPrice } =
                    promoGroup ?? {};
                const targetTypeLabel = getTargetDisplayLabel(targetType);
                if (!totalPrice) {
                    return null;
                }
                return (
                    <React.Fragment key={`${promoCode}-${targetType}`}>
                        <Text.Body
                            tag="dt"
                            emphasis="1"
                            style={{ color: "inherit" }}
                        >
                            {campaignCode || promoCode}
                            {!!targetTypeLabel && `: ${targetTypeLabel}`}
                        </Text.Body>
                        <Text.Body
                            tag="dd"
                            emphasis="1"
                            style={{ color: "inherit" }}
                        >
                            {formatCurrency(totalPrice)}
                        </Text.Body>
                    </React.Fragment>
                );
            })}
        </dl>
    );
};
